<template>
  <div class="information">
    <van-nav-bar
            title="个人信息"
            left-text=""
            right-text="保存"
            left-arrow
            @click-left="onClickLeft"
            @click-right="onClickRight"
    />
    <div class="info_detail">
      <div class="basic_title">基本信息</div>
      <div class="form_content">
        <div class="form_item">
          <div class="item_title">姓名<span>*</span></div>
          <van-field v-model="form.name" placeholder="请填写用户名" />
        </div>
        <div class="form_item">
          <div class="item_title">手机号</div>
          <van-field v-model="form.mobile" type="tel" placeholder="请填写手机号" />
        </div>
        <div class="form_item">
          <div class="item_title">{{tabIndex==1?'入职年份':'入学年份'}}</div>
          <van-field v-model="form.year" :placeholder="tabIndex==1?'请选择入职年份':'请选择入学年份'" readonly @click="handleYear"/>
        </div>
        <div class="form_item" v-if="tabIndex!=1">
          <div class="item_title">就读院系</div>
          <van-field v-model="form.learnDept" placeholder="请填写院系" />
        </div>
        <div class="form_item" v-if="tabIndex!=1">
          <div class="item_title">就读专业</div>
          <van-field v-model="form.major" placeholder="请填写专业" />
        </div>
        <div class="form_item" v-if="tabIndex==1">
          <div class="item_title">工作部门</div>
          <van-field v-model="form.workDept" placeholder="请输入您的工作部门" />
        </div>
      </div>
    </div>
    <div class="school_logo"><img src="../../assets/school_logo_new.png" alt=""></div>
    <van-popup v-model="showPickerY" position="bottom">
      <van-datetime-picker
              :type="yearType"
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              title="选择入学年份"
              @cancel="onCancel"
              @confirm="onConfirmTime"/>
    </van-popup>
  </div>
</template>

<script>
import {personalInfo, formCommit} from '../../utils/ajaxInterface'
import { Dialog } from 'vant'
export default {
  name: 'index',
  data () {
    return {
      tabs: ['校友', '教职工', '在校学生'],
      tabIndex: 1,
      form: {name: '', mobile: '', year: '', learnDept: '', major: '', workDept: ''},
      showPickerY: false,
      yearType: 'year-month',
      minDate: new Date(1951, 0, 1),
      maxDate: new Date(2026, 11, 31),
      currentDate: new Date()
    }
  },
  created () {
    this.getPersonalInfo()
  },
  methods: {
    onCancel () {
      this.showPickerY = false
    },
    // 选择计分年度
    onConfirmTime (val) {
      // 将字符串转换为Date对象
      var date = new Date(val)
      // 使用getFullYear()方法获取年份
      this.form.year = date.getFullYear()
      this.showPickerY = false
    },
    getPersonalInfo () {
      personalInfo().then(res => {
        this.form = res
        this.tabIndex = this.form.category - 1
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    onClickRight () {
      if (!this.form.name) {
        Dialog.alert({
          title: '提示',
          message: '请填写姓名'
        })
        return false
      }
      let params = JSON.parse(JSON.stringify(this.form))
      if (this.tabIndex == 1) {
        delete params.learnDept
        delete params.major
      } else {
        delete params.workDept
      }
      formCommit(params).then(res => {
        Dialog.alert({
          title: '提示',
          message: '保存成功'
        }).then(() => {
          this.$router.push('/personalCenter')
          // on close
        })
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    handleYear () {
      this.showPickerY = true

      this.$nextTick(() => {
        if (this.yearType === 'year-month') {
          // 删除月份列
          let columns = this.$el.querySelectorAll('.van-picker__columns .van-picker-column')
          if (columns.length === 2) {
            columns[1].parentElement.removeChild(columns[1])
          }
        }
      })
    },
    onClickLeft () {
      this.$router.push('/personalCenter')
    }
  }
}
</script>

<style lang="less" scoped>
  //垂直居中
  .information {
    .school_logo{
      position: fixed;
      width: 100%;
      height: 24px;
      left: 0;
      right: 0;
      bottom: 30px;
      text-align: center;
      img{
        width: 160px;
        height: 100%;
      }
    }
    .info_detail{
      width: 100%;
      margin-top: 10px;
      padding: 12px 16px;
      box-sizing: border-box;
      background-color: #ffffff;
      .basic_title{
        font-weight: 500;
        font-size: 16px;
        color: #111111;
      }
      .form_content {
        /*margin-top: 20px;*/
        .form_item{
          width: 100%;
          height: 60px;
          border-bottom: 1px solid #DADADA;
          border-radius: 2px;
          display: flex;
          /*padding: 0 14px;*/
          box-sizing: border-box;
          align-items: center;
          margin-bottom: 12px;
          /deep/ .van-cell{
            line-height: 40px;
            padding: 0 15px;
          }
          .item_title{
            width: 80px;
            font-size: 14px;
            color: #000000;
            span{
              color: red;
            }
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/information.vue